import { FILTER_LABEL_MAPPING, FilterNames } from '../../constants';
import { IFilterStateHandler, ISelectFilterOption, ISelectFilter } from '../../../shop-ui/components/search-page/interfaces';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import AbstractSelectFilterHandler from '../../../shop-ui/includes/filter-state/AbstractSelectFilterHandler';

export default class GenderFilterHandler extends AbstractSelectFilterHandler implements IFilterStateHandler {
    public createQueryParams = (filter: ISelectFilter, params: object): void => {
        params[FilterNames.GENDER] = filter.options
            .filter(option => option.selected)
            .map(selectedOption => selectedOption.value);
    };

    public resetQueryParams = (params: object): void => {
        params[FilterNames.GENDER] = [];
    };

    public getSelectedOptions = (filter: ISelectFilter): ISelectFilterOption[] => filter.options.filter(option => option.selected)
        .map(option => ({
            ...option,
            label: translate(FILTER_LABEL_MAPPING[FilterNames.GENDER][option.value], 'article-list-filter'),
        }));

    public updateSelectedOptions = (filter: ISelectFilter, selectedValues: string[]): void => {
        filter.options = filter.options.map((option: ISelectFilterOption) => {
            option.selected = selectedValues.includes(option.value);

            return option;
        });
    };
}
